import request from '../../axios';
import {IOrderResponse} from './types';

export const getOrderDetails = async ({
  orderGuid,
  storeOrderGuid,
}: {
  orderGuid?: string;
  storeOrderGuid?: string;
}) => {
  const {data}: {data: IOrderResponse} = await request.get(
    `/api/v2/order/detail-user-order/${orderGuid}`,
    {
      params: {store_order_guid: storeOrderGuid},
    },
  );

  return data;
};
